import {Box, createStyles} from '@mantine/core';
import React from 'react';

import {ConjugationSite} from 'molbio/adcs/conjugation-sites/AdcConjugationSiteConstants';
import {
  conjugationSiteKey,
  formatConjugationSite,
} from 'molbio/adcs/conjugation-sites/AdcConjugationSiteUtils';
import getTestProps from 'test/lib/cypress/getTestProps';
import Chip, {ChipSize} from 'ui-library/chips/Chip';
import {CHIP_DISPLAY_LIMIT_TABLE_ROW} from 'ui-library/chips/ChipConstants';
import {BaseChipList} from 'ui-library/chips/ChipList';

const useStyles = createStyles((theme) => ({
  chip: {
    marginTop: theme.spacing.xxs,
    marginBottom: theme.spacing.xxs,
  },
}));

interface ConjugationSiteChipsProps {
  sites: Array<ConjugationSite>;
}

/** Chips for the given conjugation sites, showing a few with an option to expand the rest. */
export function ConjugationSiteChips({sites}: ConjugationSiteChipsProps): JSX.Element | null {
  const {classes} = useStyles();
  return (
    <BaseChipList
      chips={sites.map((site) => (
        <Chip
          key={conjugationSiteKey(site)}
          className={classes.chip}
          size={ChipSize.TABLE_CELL}
          text={formatConjugationSite(site)}
        />
      ))}
      maxChips={CHIP_DISPLAY_LIMIT_TABLE_ROW}
      chipSize={ChipSize.TABLE_CELL}
      showMoreSize={ChipSize.TABLE_CELL}
      isVertical={false}
    />
  );
}

interface AdcConjugationSitesDisplayProps {
  sites: Array<ConjugationSite>;
}

/** Read-only display of a Conjugation sites cell. Reads nothing from the row, so it renders outside tables. */
export default function AdcConjugationSitesDisplay({sites}: AdcConjugationSitesDisplayProps): JSX.Element {
  return (
    <Box {...getTestProps({component: 'AdcConjugationSitesDisplay', element: 'root'})}>
      <ConjugationSiteChips sites={sites} />
    </Box>
  );
}
